import React, { useEffect } from "react";
import { useTaskInfiniteScroll } from "../../hooks/useTaskInfiniteScroll";
import { NoteCard } from "../Note";
import TaskCard from "./TaskCard";

// Styles for ExpandedStackView
const styles = {
  initialLoadingState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "60px 40px",
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    textAlign: "center",
    color: "#3498db",
    fontSize: "14px",
    fontWeight: 500,
  },
  loadingMoreIndicator: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    padding: "20px",
    color: "#3498db",
    fontSize: "14px",
    marginTop: "16px",
    borderTop: "1px solid #e9ecef",
  },
  noMoreNotesMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "6px",
    color: "#6c757d",
    fontSize: "12px",
    marginTop: "16px",
    borderTop: "1px solid #e9ecef",
  },
  expandedContainer: {
    width: "100%",
    marginBottom: "20px",
  },
  expandedHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    backgroundColor: "#f8f9fa",
    borderBottom: "2px solid #e9ecef",
    borderRadius: "8px 8px 0 0",
    minHeight: "40px",
    position: "sticky",
    top: "40px",
    zIndex: "1",
  },
  tasksContainer: {
    marginTop: "20px",
    padding: "0 20px 20px 20px",
  },
  tabsRowContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    gap: "16px",
    marginBottom: "5px",
    borderBottom: "1px solid #e9ecef",    
    position: "sticky",
    top: "0",
    backgroundColor: "white",
    zIndex: "5",
    flexWrap: "wrap",
    alignSelf: "stretch",
},
  tabsContainer: {
    display: "flex",
    gap: "4px",
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    scrollbarWidth: "thin",
    msOverflowStyle: "auto",
    WebkitOverflowScrolling: "touch",
    paddingBottom: "5px",
    flex: 1,
  },
  tabButton: {
    padding: "5px 10px",
    background: "transparent",
    border: "none",
    borderRadius: "8px 8px 0 0",
    fontSize: "13px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    position: "relative",
    marginBottom: "-1px",
  },
  tabCount: {
    marginLeft: "3px",
    padding: "1px 3px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: 600,
    minWidth: "20px",
    textAlign: "center",
  },
  assigneeFilterInline: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "0 0 0 16px",
    borderLeft: "1px solid #e9ecef",
    flexShrink: 0,
  },
  assigneeFilterLabelInline: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#6c757d",
    whiteSpace: "nowrap",
  },
  assigneeListInline: {
    display: "flex",
    alignItems: "center",
  },
  assigneeAvatarsInline: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  assigneeRingInline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    border: "2px solid #e9ecef",
    backgroundColor: "#6c757d",
    color: "white",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "11px",
    fontWeight: 600,
    position: "relative",
    marginLeft: "0",
    flexShrink: 0,
  },
  assigneeRingInitialsInline: {
    fontWeight: 600,
    fontSize: "11px",
  },
  assigneeActiveDotInline: {
    position: "absolute",
    bottom: "-2px",
    right: "-2px",
    width: "9px",
    height: "9px",
    backgroundColor: "#28a745",
    borderRadius: "50%",
    border: "2px solid white",
  },
  assigneeClearRingInline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    backgroundColor: "#dc3545",
    color: "white",
    border: "2px solid #e9ecef",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "9px",
    marginRight: "2px",
    zIndex: 20,
    flexShrink: 0,
  },
  assigneeMoreBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: "#e9ecef",
    color: "#6c757d",
    fontSize: "11px",
    fontWeight: 600,
    marginLeft: "-4px",
    border: "2px solid white",
    cursor: "default",
  },
  assigneeLoading: {
    padding: "4px 8px",
    color: "#6c757d",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  tasksGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "16px",
  },
  taskWrapper: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
   
  },
  loadingState: {
    padding: "40px",
    textAlign: "center",
    color: "#666",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
  },
  spinner: {
    fontSize: "24px",
    color: "#3498db",
    marginBottom: "10px",
    display: "block",
  },
  emptyState: {
    padding: "40px",
    textAlign: "center",
    color: "#999",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
  },
  emptyTabState: {
    padding: "60px 40px",
    textAlign: "center",
    color: "#999",
    backgroundColor: "#fafafa",
    borderRadius: "8px",
    border: "1px dashed #dee2e6",
  },
  emptyIcon: {
    fontSize: "32px",
    marginBottom: "10px",
    opacity: 0.5,
    display: "block",
  },
  createButton: {
    marginTop: "10px",
    padding: "8px 16px",
    backgroundColor: "#3498db",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 500,
    transition: "background-color 0.2s ease",
  },
  expandedTaskSection: {
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },
  taskNotesSection: {
    marginTop: "16px",
  },
  notesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
  },
  noNotesMessage: {
    padding: "30px",
    textAlign: "center",
    color: "#999",
    backgroundColor: "white",
    borderRadius: "8px",
    fontSize: "13px",
  },
  clearFilterButton: {
    marginTop: "12px",
    padding: "6px 12px",
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    transition: "background-color 0.2s ease",
  },
};

const ExpandedStackView = ({
  job,
  searchTerm,
  hasActiveFilters,
  openAiDialogForJob,
  renderStackedImageIcon,
  selectedRow,
  handleRowClick,
  handleRowDoubleClick,
  handleAddFromRow,
  handleEdit,
  handleDelete,
  handleViewAttachments,
  handleReplyToNote,
  handlePriorityClick,
  handlePriorityMouseEnter,
  handlePriorityMouseLeave,
  handleNoteTextMouseEnter,
  handleNoteTextMouseLeave,
  handleLinkedNoteClick,
  handleLinkedNoteMouseEnter,
  handleLinkedNoteMouseLeave,
  isNoteReply,
  getReplyNoteId,
  isOriginalNoteExists,
  userStatusMap,
  loadingUsers,
  getPriorityValue,
  manuallyUpdatedPriorities,
  shouldShowNotePopup,
  toggleStackExpansion,
  onOpenEdit,
  onCreateTask,
  onOpenSlideshow,
  tasks,
  loadingTasks,
  expandedTasks,
  expandedTask,
  onTaskToggle,
  onTaskClick,
  onTaskEdit,
  onTaskDelete,
  onTaskStatusChange,
  notesByTask,
  loadingNotesByTask,
  onCollapseTask,
  userId,
  fetchTasksForJob,
  activeTab,
  onTabChange,
  TASK_STATUSES,
  ALL_TASKS_TAB,
  isAnyStackExpanded,
  hasAnyTaskExpanded,
  expandedStacks,
  stackedJobs,
  highlightedTaskId,
  assigneeFilters,
  jobUsers,
  loadingUsersByJob,
  onAssigneeFilter,
  clearAssigneeFilter,
  fetchNotesForTask,
  loadMoreTaskNotes,
  taskPagination,
  fetchJobPermissionUsers,
  refreshNotes
}) => {
  const expandedTaskPagination = expandedTask
    ? taskPagination?.[expandedTask.id]
    : null;

  const hasMoreNotes = expandedTaskPagination?.hasMore || false;
  const isLoadingNotes = loadingNotesByTask[expandedTask?.id] || false;

  // Use the infinite scroll hook for the expanded task
  const { lastNoteRef } = useTaskInfiniteScroll({
    taskId: expandedTask?.id,
    jobId: job.jobId,
    hasMore: hasMoreNotes,
    loading: isLoadingNotes,
    loadMore: loadMoreTaskNotes,
    enabled: !!expandedTask && !isLoadingNotes,
  });

  useEffect(() => {
    if (job?.jobId && fetchJobPermissionUsers) {
      fetchJobPermissionUsers(job.jobId);
    }
  }, [job?.jobId, fetchJobPermissionUsers]);

  // Early return after all hooks
  if (!job) return null;

  const jobName = job.jobName;
  const projectName =
    job.projectName ||
    job.project?.name ||
    job.project?.projectName ||
    job.project?.project?.name ||
    job.projectName;

  const taskCount = tasks ? tasks.length : 0;
  const selectedAssigneeIds = assigneeFilters[job.jobId];

  const taskSummary = tasks.reduce((acc, task) => {
    acc[task.status] = (acc[task.status] || 0) + 1;
    return acc;
  }, {});

  const getFilteredTasks = () => {
    let filteredTasks = tasks;

    if (activeTab === ALL_TASKS_TAB.id) {
      filteredTasks = filteredTasks.filter(
        (task) => task.status !== TASK_STATUSES.ARCHIVED.id,
      );
    } else if (activeTab === TASK_STATUSES.ARCHIVED.id) {
      filteredTasks = filteredTasks.filter(
        (task) => task.status === TASK_STATUSES.ARCHIVED.id,
      );
    } else {
      filteredTasks = filteredTasks.filter((task) => task.status === activeTab);
    }

    if (selectedAssigneeIds && selectedAssigneeIds.length > 0) {
      filteredTasks = filteredTasks.filter((task) => {
        return task.assignedUsers?.some((user) =>
          selectedAssigneeIds.includes(user.userId),
        );
      });
    }

    return filteredTasks;
  };

  const filteredTasks = getFilteredTasks();

  const sortedFilteredTasks = [...filteredTasks].sort((a, b) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return dateB - dateA;
  });

  const allTabs = [
    ALL_TASKS_TAB,
    ...Object.values(TASK_STATUSES).sort((a, b) => a.order - b.order),
  ];

  const users = jobUsers[job.jobId] || [];
  const isLoadingUsers = loadingUsersByJob[job.jobId];

  return (
    <div
      key={`stack-${job.jobId || job.jobName}`}
      className="job-stack-container expanded-full-width"
      style={styles.expandedContainer}
    >
      <div className="expanded-stack">
        <div
          className="tasks-container"
          style={{
            ...styles.tasksContainer,
            paddingTop: expandedTask ? "16px" : undefined,
          }}
        >
          {loadingTasks ? (
            <div style={styles.loadingState}>
              <i className="fas fa-spinner fa-spin" style={styles.spinner} />
              <div>Loading tasks for {jobName}...</div>
            </div>
          ) : (
            <>
              {tasks.length === 0 ? (
                <div style={styles.emptyState}>
                  <i className="fas fa-tasks" style={styles.emptyIcon} />
                  <p>No tasks found for this job</p>
                  <button
                    onClick={() => onCreateTask(job)}
                    style={styles.createButton}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2980b9";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3498db";
                    }}
                  >
                    <i className="fas fa-plus" style={{ marginRight: "6px" }} />
                    Create First Task
                  </button>
                </div>
              ) : (
                <>
                  {expandedTask ? (
                    <div style={styles.expandedTaskSection}>
                      <div style={styles.taskNotesSection}>
                        {loadingNotesByTask[expandedTask.id] &&
                        (!notesByTask[expandedTask.id] ||
                          notesByTask[expandedTask.id].length === 0) ? (
                          <div style={styles.initialLoadingState}>
                            <i
                              className="fas fa-spinner fa-spin"
                              style={styles.spinner}
                            />
                            <span>
                              Loading notes for {expandedTask.title}...
                            </span>
                          </div>
                        ) : (
                          <>
                            <div style={styles.notesGrid}>
                              {notesByTask[expandedTask.id]?.map(
                                (note, index) => {
                                  const getNotePriority = (note) => {
                                    if (!note) return null;
                                    if (
                                      manuallyUpdatedPriorities &&
                                      manuallyUpdatedPriorities[note.id] !==
                                        undefined
                                    ) {
                                      return manuallyUpdatedPriorities[note.id];
                                    }
                                    return (
                                      note.priority || getPriorityValue(note)
                                    );
                                  };

                                  const priorityValue = getNotePriority(note);
                                  const noteWithPriority = {
                                    ...note,
                                    priority: priorityValue,
                                    priorityValue: priorityValue,
                                    Priority: priorityValue,
                                  };

                                  const isLastNote =
                                    index ===
                                    notesByTask[expandedTask.id].length - 1;

                                  return (
                                    <div
                                      key={`${note.id}-${priorityValue}`}
                                      ref={isLastNote ? lastNoteRef : null}
                                    >
                                      <NoteCard
                                        userId={userId}
                                        note={noteWithPriority}
                                        selectedRow={selectedRow}
                                        searchTerm={searchTerm}
                                        viewMode="stacked"
                                        handleRowClick={handleRowClick}
                                        handleRowDoubleClick={
                                          handleRowDoubleClick
                                        }
                                        handleAddFromRow={handleAddFromRow}
                                        handleEdit={handleEdit}
                                        handleDelete={handleDelete}
                                        handleViewAttachments={
                                          handleViewAttachments
                                        }
                                        handleReplyToNote={handleReplyToNote}
                                        handlePriorityClick={
                                          handlePriorityClick
                                        }
                                        handlePriorityMouseEnter={
                                          handlePriorityMouseEnter
                                        }
                                        handlePriorityMouseLeave={
                                          handlePriorityMouseLeave
                                        }
                                        handleNoteTextMouseEnter={
                                          handleNoteTextMouseEnter
                                        }
                                        handleNoteTextMouseLeave={
                                          handleNoteTextMouseLeave
                                        }
                                        handleLinkedNoteClick={
                                          handleLinkedNoteClick
                                        }
                                        handleLinkedNoteMouseEnter={
                                          handleLinkedNoteMouseEnter
                                        }
                                        handleLinkedNoteMouseLeave={
                                          handleLinkedNoteMouseLeave
                                        }
                                        renderCardImageIcon={
                                          renderStackedImageIcon
                                        }
                                        isNoteReply={isNoteReply}
                                        getReplyNoteId={getReplyNoteId}
                                        isOriginalNoteExists={
                                          isOriginalNoteExists
                                        }
                                        userStatusMap={userStatusMap}
                                        loadingUsers={loadingUsers}
                                        getPriorityValue={() => priorityValue}
                                        manuallyUpdatedPriorities={
                                          manuallyUpdatedPriorities
                                        }
                                        shouldShowNotePopup={
                                          shouldShowNotePopup
                                        }
                                      />
                                    </div>
                                  );
                                },
                              )}
                            </div>

                            {isLoadingNotes &&
                              notesByTask[expandedTask.id]?.length > 0 &&
                              hasMoreNotes && (
                                <div style={styles.loadingMoreIndicator}>
                                  <i className="fas fa-spinner fa-spin" />
                                  <span>Loading more notes...</span>
                                </div>
                              )}

                           
                            {notesByTask[expandedTask.id]?.length === 0 &&
                              !loadingNotesByTask[expandedTask.id] && (
                                <div style={styles.noNotesMessage}>
                                  <i
                                    className="fas fa-sticky-note"
                                    style={{ opacity: 0.5, marginRight: "8px" }}
                                  />
                                  No notes yet for this task
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={styles.tabsRowContainer}>
                        <div
                          style={styles.tabsContainer}
                          className="task-tabs-responsive"
                        >
                          {allTabs.map((status) => {
                            let count = 0;
                            if (status.id === ALL_TASKS_TAB.id) {
                              count = tasks.filter(
                                (t) => t.status !== TASK_STATUSES.ARCHIVED.id,
                              ).length;
                            } else if (
                              status.id === TASK_STATUSES.ARCHIVED.id
                            ) {
                              count = taskSummary[status.id] || 0;
                            } else {
                              count = taskSummary[status.id] || 0;
                            }

                            const isActive = activeTab === status.id;

                            return (
                              <button
                                key={status.id}
                                onClick={() =>
                                  onTabChange(job.jobId, status.id)
                                }
                                style={{
                                  ...styles.tabButton,
                                  borderBottom: isActive
                                    ? `2px solid ${status.color}`
                                    : "2px solid transparent",
                                  color: isActive ? status.color : "#666",
                                  fontWeight: isActive ? 600 : 400,
                                }}
                                className="task-tab-button"
                                onMouseEnter={(e) => {
                                  if (!isActive) {
                                    e.currentTarget.style.backgroundColor =
                                      "#f8f9fa";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isActive) {
                                    e.currentTarget.style.backgroundColor =
                                      "transparent";
                                  }
                                }}
                              >
                                <i
                                  className={`fas ${status.icon}`}
                                  style={{
                                    marginRight: "8px",
                                    fontSize: "12px",
                                    color: status.color,
                                  }}
                                />
                                <span className="tab-name">{status.name}</span>
                                {count > 0 && (
                                  <span
                                    style={{
                                      ...styles.tabCount,
                                      backgroundColor: isActive
                                        ? status.color
                                        : "#e9ecef",
                                      color: isActive ? "white" : "#666",
                                    }}
                                  >
                                    {count}
                                  </span>
                                )}
                              </button>
                            );
                          })}
                        </div>

                        {users.length > 0 && !expandedTask && (
                          <div style={styles.assigneeFilterInline}>
                            <div style={styles.assigneeFilterLabelInline}>
                              <i
                                className="fas fa-user-check"
                                style={{ fontSize: "16px" }}
                                title="Filter by user"
                              />
                            </div>
                            <div style={styles.assigneeListInline}>
                              {isLoadingUsers ? (
                                <div style={styles.assigneeLoading}>
                                  <i className="fas fa-spinner fa-spin" />
                                </div>
                              ) : (
                                <div style={styles.assigneeAvatarsInline}>
                                  {selectedAssigneeIds &&
                                    selectedAssigneeIds.length > 0 && (
                                      <button
                                        onClick={() =>
                                          clearAssigneeFilter(job.jobId)
                                        }
                                        style={styles.assigneeClearRingInline}
                                        title="Clear all filters"
                                      >
                                        <i
                                          className="fas fa-times"
                                          style={{ fontSize: "10px" }}
                                        />
                                      </button>
                                    )}

                                  {users.slice(0, 8).map((user, index) => (
                                    <button
                                      key={user.id}
                                      onClick={() =>
                                        onAssigneeFilter(job.jobId, user.id)
                                      }
                                      style={{
                                        ...styles.assigneeRingInline,
                                        zIndex: users.length - index,
                                        borderColor:
                                          selectedAssigneeIds?.includes(user.id)
                                            ? "#3498db"
                                            : "#e9ecef",
                                        backgroundColor:
                                          selectedAssigneeIds?.includes(user.id)
                                            ? "#3498db"
                                            : user.color || "#6c757d",
                                        transform: `translateX(${index * -6}px)`,
                                        boxShadow:
                                          selectedAssigneeIds?.includes(user.id)
                                            ? "0 0 0 2px rgba(52, 152, 219, 0.3)"
                                            : "none",
                                      }}
                                      title={user.name}
                                    >
                                      <span
                                        style={
                                          styles.assigneeRingInitialsInline
                                        }
                                      >
                                        {user.initials}
                                      </span>
                                      {selectedAssigneeIds?.includes(
                                        user.id,
                                      ) && (
                                        <span
                                          style={styles.assigneeActiveDotInline}
                                        />
                                      )}
                                    </button>
                                  ))}

                                  {users.length > 8 && (
                                    <div
                                      style={{
                                        ...styles.assigneeMoreBadge,
                                        transform: `translateX(${-6 * 8}px)`,
                                      }}
                                      title={`${users.length - 8} more users`}
                                    >
                                      +{users.length - 8}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div
                        style={styles.tasksGrid}
                        
                      >
                        {sortedFilteredTasks.length > 0 ? (
                          sortedFilteredTasks.map((task) => (
                            <div
                              key={task.id}
                              style={styles.taskWrapper}
                              className="task-wrapper-responsive"
                            >
                              <TaskCard
                                task={task}
                                onEdit={onTaskEdit}
                                onDelete={onTaskDelete}
                                onStatusChange={onTaskStatusChange}
                                onClick={onTaskClick}
                                onToggle={onTaskToggle}
                                isExpanded={false}
                                showToggle={true}
                                userId={userId}
                                isHighlighted={highlightedTaskId === task.id}
                                onAddNote={(task) => {
                                  const userFromStorage = JSON.parse(
                                    localStorage.getItem("user") || "{}",
                                  );

                                  const prefilledData = {
                                    date: new Date()
                                      .toISOString()
                                      .split("T")[0],
                                    jobId: job?.jobId || job?.id,
                                    job: job?.jobName || job?.name,
                                    projectId: job?.projectId,
                                    project:
                                      job?.projectName || job?.project?.name,
                                    workspaceId: job?.workspaceId,
                                    workspace:
                                      job?.workspaceName ||
                                      job?.workspace ||
                                      job?.notes?.[0]?.workspace,
                                    taskName: task.title,
                                    taskId: task.id,
                                    taskFriendlyId: task.friendlyId,
                                    userId: userFromStorage.id,
                                    taskDescription: task.description,
                                    taskStatus: task.status,
                                  };

                                  if (handleAddFromRow) {
                                    handleAddFromRow(prefilledData);
                                  }
                                }}
                                job={job}
                                fetchTasksForJob={fetchTasksForJob}
                                refreshNotes={refreshNotes}
                              />
                            </div>
                          ))
                        ) : (
                          <div style={styles.emptyTabState}>
                            <i
                              className={`fas ${
                                activeTab === ALL_TASKS_TAB.id
                                  ? "fa-tasks"
                                  : activeTab === TASK_STATUSES.ARCHIVED.id
                                    ? "fa-archive"
                                    : TASK_STATUSES[
                                        Object.keys(TASK_STATUSES).find(
                                          (key) =>
                                            TASK_STATUSES[key].id === activeTab,
                                        )
                                      ]?.icon || "fa-tasks"
                              }`}
                              style={{
                                fontSize: "32px",
                                marginBottom: "12px",
                                opacity: 0.5,
                                color:
                                  activeTab === ALL_TASKS_TAB.id
                                    ? "#3498db"
                                    : activeTab === TASK_STATUSES.ARCHIVED.id
                                      ? "#6c757d"
                                      : TASK_STATUSES[
                                          Object.keys(TASK_STATUSES).find(
                                            (key) =>
                                              TASK_STATUSES[key].id ===
                                              activeTab,
                                          )
                                        ]?.color,
                              }}
                            />
                            <p>
                              {selectedAssigneeIds &&
                              selectedAssigneeIds.length > 0
                                ? `No tasks assigned to selected users in ${activeTab === ALL_TASKS_TAB.id ? "this job" : activeTab === TASK_STATUSES.ARCHIVED.id ? "archived" : "this status"}`
                                : `No tasks in ${activeTab === ALL_TASKS_TAB.id ? "this job" : activeTab === TASK_STATUSES.ARCHIVED.id ? "archived" : "this status"}`}
                            </p>
                            {selectedAssigneeIds &&
                              selectedAssigneeIds.length > 0 && (
                                <button
                                  onClick={() => clearAssigneeFilter(job.jobId)}
                                  style={styles.clearFilterButton}
                                >
                                  Clear All Assignee Filters (
                                  {selectedAssigneeIds.length})
                                </button>
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandedStackView;